export default __webpack_public_path__ + "3c7b04a6e8ba690be283826c13a1ac4e.jpg";